<template>
<div class="profile-intro mb-4" style="background: linear-gradient(177.23deg, #05CD85 -13.49%, #3A49F9 109.75%);-webkit-background: linear-gradient(177.23deg, #05CD85 -13.49%, #3A49F9 109.75%);border-radius:0 !important;padding:6rem 3rem;">

    <!-- <img class="profile-img xl" :src="detailTop.picture || '/img/user.jpg'" v-if="detailTop" style="background:#ffffff"> -->
    <vue-qrcode class="profile-img xl" :value="detailTop.no_rm" />
    <!-- <barcode class="mr-5" :value="detailTop.no_rm" background="white" width="2"/> -->
    <!-- <vue-qrcode  class="profile-img xl" :value="'https://pbec-simrs.web.app/ralan/form/'+detailTop.no_rm" /> -->
    <div class="profile-info">
        <p v-if="detailTop && detailTop.topSubtitle" class="mb-2" style="font-size:40px;color:rgba(255,255,255,.54)">{{detailTop.topSubtitle}}</p>
        <h4 v-if="detailTop && detailTop.title" class="mb-3" style="font-size:60px;color:#ffffff">{{detailTop.title}}</h4>
        <p v-if="detailTop && detailTop.subtitle" class="mb-2" style="font-size:40px;color:rgba(255,255,255,.54)">{{detailTop.subtitle}}</p>
    </div>
</div>
</template>

<script>
import VueQrcode from 'vue-qrcode'
// import VueBarcode from 'vue-barcode'
export default {
  name: 'PatientCard',
  props: {
    detailTop:Object
  },
  components: {
    VueQrcode,
    // 'barcode':VueBarcode
  }
}
</script>